import { useRouter } from 'next/router';

import { AssignmentsTabs } from '@consts';

export function useCurrentAssignmentsTab(): AssignmentsTabs | undefined {
  const router = useRouter();
  const tab = router.query.tab as string;
  const values = Object.values(AssignmentsTabs) as string[];
  if (values.includes(tab)) {
    return tab as AssignmentsTabs;
  }
  return undefined;
}
